import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { useUserMemory } from './useUserMemory';

export const useInitialUserMemory = () => {
    const auth = useAuth();
    const { fetchMemory } = useUserMemory();
    const userMemoryEnabled = useAppSelector(
        (state: RootState) => state.app.serviceInfo.featureFlags.UserMemoryEnabled,
    );

    // Seed the store once at load (when the org has the feature) so the nav rail can decide whether to
    // show the Minnen tab without the user first opening Settings. The Settings switch and the Minnen
    // page each still refetch on mount for freshness; this only primes the sidebar's visibility gate.
    useEffect(() => {
        if (auth.isAuthenticated && userMemoryEnabled) {
            void fetchMemory();
        }
    }, [auth.isAuthenticated, userMemoryEnabled, fetchMemory]);
};
